import {
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
} from '@modeso/types__aumico-lib-annualreport-be';

export interface IItemParentGroupAndIndexes {
    parent: IAccountMappingTemplateGroup | IAccountMappingTemplateGroupItemFLI;
    indexInItems: number;
    indexInSortedItems: number;
}
